import {
  Avatar,
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Logout from "@mui/icons-material/Logout";
import { useState } from "react";
import { getAppLogoutReturnUrl } from "../core";
import { useAuth } from "../hooks/useAuth";

interface UserMenuProps {
  collapsed: boolean;
}

export function AuthUserMenu({ collapsed }: UserMenuProps) {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const openUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    logout({
      logoutParams: {
        returnTo: getAppLogoutReturnUrl(),
      },
    });
  };

  const getInitials = (name: string | undefined) => {
    if (!name) return "?";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <Box mt={2} mb={2.5}>
      <ListItemButton
        onClick={openUserMenu}
        sx={{
          justifyContent: collapsed ? "center" : "initial",
          px: 2,
          py: 1,
          minHeight: 48,
          maxHeight: 48,
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: "unset",
            justifyContent: "center",
            mr: collapsed ? 0 : 2,
          }}
        >
          <Avatar src={user?.picture} alt={user?.name || "User"} sx={{ width: 32, height: 32 }}>
            {getInitials(user?.name)}
          </Avatar>
        </ListItemIcon>
        {!collapsed && (
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {user?.name || "User"}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "block",
              }}
            >
              {user?.email || ""}
            </Typography>
          </Box>
        )}
        <ListItemIcon
          sx={{
            minWidth: "unset",
            justifyContent: "center",
            opacity: collapsed ? 0 : 1,
          }}
        >
          <ChevronRight />
        </ListItemIcon>
      </ListItemButton>

      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          ml: 1.2,
          mt: 1.8,
        }}
      >
        {/* TODO: add a Help item above Logout, linking to the JSM "Partner Support" portal
            (per CPD-46 notes), once that integration exists. */}
        <MenuItem onClick={handleLogout} sx={{ height: 48, px: 2 }}>
          <ListItemIcon sx={{ minWidth: 32, mr: 2 }}>
            <Logout />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </MenuItem>
      </Menu>
    </Box>
  );
}
